import * as E from 'fp-ts/Either';
import { config } from '../config';
import {
  insertItem,
  updateItem,
  page as commonPage,
  removeItem,
} from './common';

export type App = {
  _id: string;
  shortCode: string;
  friendlyName: string;
  requiredLicenseFields: string[];
  sharedLicenseData: Record<string, any>;
  updatedAt: string;
  createdAt: string;
  deletedAt?: string;
};

export const single = async (token: string, appId: string) => {
  const result = await fetch(
    `${config.apiUrl}/cms/v1/apps/${encodeURIComponent(appId)}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  const body = await result.json();

  return result.status === 200 ? E.right(body) : E.left(body);
};

export const page = commonPage<App>(`${config.apiUrl}/cms/v1/apps`);

export const remove = removeItem(`${config.apiUrl}/cms/v1/apps`);

export const insert = insertItem<App>(`${config.apiUrl}/cms/v1/apps`);

export const update = updateItem<App>(`${config.apiUrl}/cms/v1/apps`);

export const enumerateTypes = async (token: string) => {
  const result = await fetch(`${config.apiUrl}/cms/v1/apps/types`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const body = await result.json();

  return result.status === 200 ? E.right(body) : E.left(body);
};
